import { NNATSuppliers } from 'Quotes/types/supplier';

export const isPriceNNAT = (a_end_access_type: string | null, b_end_access_type: string | null) =>
  NNATSuppliers.includes(a_end_access_type) || NNATSuppliers.includes(b_end_access_type);

export const isSupplierNNAT = (accessType: string | null) => NNATSuppliers.includes(accessType);
